module.exports = __webpack_public_path__ + "static/media/Original Korean Article from - TATHAGATA - message - gwangjang.19054e25.pdf";